import { JsonObject, JsonProperty } from 'json2typescript';

import { CountryClientInterface } from '../../../core';
import { StringAdapter } from '../../client/helpers/serializer/adapters/string.adapter';

@JsonObject('CountryClient')
export class CountryClient implements CountryClientInterface {
    @JsonProperty('CountryIdentification', StringAdapter, true)
    private _id: string = undefined;

    get id(): string {
        return this._id;
    }
}
